import { motion } from "framer-motion";
import { PhoneCall, House, ChartLine, FileText, Hammer } from "@phosphor-icons/react";

const steps = [
    { num: "01", icon: PhoneCall, title: "Demande de rendez-vous", desc: "Contact rapide et conseil gratuit." },
    { num: "02", icon: House, title: "Visite sur site", desc: "Diagnostic complet du bâtiment." },
    { num: "03", icon: ChartLine, title: "Analyse énergétique", desc: "Étude thermique en bureau d'étude." },
    { num: "04", icon: FileText, title: "Rapport détaillé", desc: "Document conforme livré sous 24-48h." },
    { num: "05", icon: Hammer, title: "Recommandations", desc: "Plan d'action travaux + accompagnement." },
];

export default function Process() {
    return (
        <section id="process" data-testid="process-section" className="relative py-24 lg:py-28 bg-white">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <span className="eyebrow justify-center">Comment ça fonctionne</span>
                    <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-lumos-ink leading-[1.05]">
                        Cinq étapes,<br />
                        <span className="font-serif-display text-lumos-blue">une expertise complète.</span>
                    </h2>
                </div>

                {/* Desktop: horizontal timeline */}
                <div className="hidden lg:block relative">
                    {/* horizontal line */}
                    <div className="absolute top-9 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-lumos-blue/20 via-lumos-blue to-lumos-green/40" />
                    <div className="grid grid-cols-5 gap-6 relative">
                        {steps.map((s, i) => {
                            const Icon = s.icon;
                            return (
                                <motion.div
                                    key={s.num}
                                    initial={{ opacity: 0, y: 26 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-80px" }}
                                    transition={{ duration: 0.5, delay: i * 0.12 }}
                                    className="flex flex-col items-center text-center"
                                    data-testid={`step-${i}`}
                                >
                                    <div className="relative">
                                        <div className="w-[72px] h-[72px] rounded-full bg-white border-2 border-lumos-blue shadow-[0_8px_24px_-6px_rgba(0,175,255,0.35)] grid place-items-center relative z-10">
                                            <Icon size={28} weight="duotone" className="text-lumos-blue" />
                                        </div>
                                        <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-lumos-amber text-white text-xs font-extrabold grid place-items-center z-20 shadow-lg">
                                            {s.num}
                                        </div>
                                    </div>
                                    <h3 className="mt-6 font-display font-bold text-lg text-lumos-ink">{s.title}</h3>
                                    <p className="mt-2 text-sm text-lumos-muted max-w-[200px]">{s.desc}</p>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>

                {/* Mobile: vertical timeline */}
                <div className="lg:hidden relative pl-8">
                    <div className="absolute left-[31px] top-2 bottom-2 w-0.5 bg-gradient-to-b from-lumos-blue/30 via-lumos-blue to-lumos-green/30" />
                    <div className="space-y-8">
                        {steps.map((s, i) => {
                            const Icon = s.icon;
                            return (
                                <motion.div
                                    key={s.num}
                                    initial={{ opacity: 0, x: -16 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true, margin: "-50px" }}
                                    transition={{ duration: 0.5, delay: i * 0.08 }}
                                    className="relative flex items-start gap-5"
                                >
                                    <div className="relative -ml-8 flex-shrink-0">
                                        <div className="w-16 h-16 rounded-full bg-white border-2 border-lumos-blue grid place-items-center shadow-md">
                                            <Icon size={24} weight="duotone" className="text-lumos-blue" />
                                        </div>
                                        <div className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-lumos-amber text-white text-[11px] font-extrabold grid place-items-center shadow">
                                            {s.num}
                                        </div>
                                    </div>
                                    <div className="pt-2">
                                        <h3 className="font-display font-bold text-lg text-lumos-ink">{s.title}</h3>
                                        <p className="mt-1.5 text-sm text-lumos-muted">{s.desc}</p>
                                    </div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
